export const truncateString = (str, length) => {
  if (str.length > length) {
    return str.substring(0, length) + "..."; // Adding ellipsis to indicate truncation
  }
  return str;
};
